module.exports = __webpack_public_path__ + "static/media/cat.3b5986a0.png";